export var ACTION;
(function (ACTION) {
    ACTION["WITHDRAW_AMOUNT"] = "WITHDRAW_AMOUNT";
    ACTION["ON_AMOUNT_CHANGE"] = "ON_AMOUNT_CHANGE";
    ACTION["SET_RECOMENDED_AMOUNT"] = "SET_RECOMENDED_AMOUNT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["CLOSE_POPUP"] = "CLOSE_POPUP";
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["AMOUNT_CONFIRM"] = "AMOUNT_CONFIRM";
    ACTION["CLOSE_ERROR_MODAL"] = "CLOSE_ERROR_MODAL";
    ACTION["FETCH_MIN_AMOUNT_DETAILS"] = "FETCH_MIN_AMOUNT_DETAILS";
})(ACTION || (ACTION = {}));
